import * as React from 'react';
import { useInput, InputProps, FieldTitle } from 'react-admin';
import { SketchPicker } from 'react-color';
import {
  FormControl,
  FormHelperText,
  Box,
  Popover,
} from '@mui/material';

const ColorInput = (props: InputProps) => {
  const {
    field,
    fieldState: { error },
    isRequired,
  } = useInput(props);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <FormControl fullWidth margin="normal" error={!!error}>
      <Box
        onClick={handleClick}
        sx={{
          width: 26,
          height: 26,
          bgcolor: field.value || '#000000',
          border: '1px solid #ccc',
          borderRadius: 1,
          cursor: 'pointer',
        }}
      />
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <SketchPicker
          color={field.value || '#000000'}
          onChange={(color: any) => field.onChange(color.hex)}
        />
        
      </Popover>

      <FormHelperText>{error?.message}</FormHelperText>
    </FormControl>
  );
};

export default ColorInput;